const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-empty ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    icon: { type: String, default: 'sparkle' },
    title: String,
    text: String,
    compact: Boolean,
  }

  CSS = `:fez {
display:block;.empty{display:flex;flex-direction:column;align-items:center;text-align:center;gap:var(--space-3);padding:var(--space-12) var(--space-6);color:var(--color-text-muted);&.compact{padding:var(--space-8) var(--space-4)}}.badge{display:inline-flex;align-items:center;justify-content:center;width:56px;height:56px;margin-bottom:var(--space-1);border-radius:var(--radius-xl);background:var(--color-accent-soft);color:var(--color-accent)}h3{font-size:var(--text-lg);color:var(--color-text)}p{max-width:420px;font-size:var(--text-md)}.actions{display:flex;gap:var(--space-2);margin-top:var(--space-2);&:empty{display:none}}
}`

  HTML = `<div class="empty" class:compact={props.compact}>
<span class="badge"><ui-icon name={props.icon} size="28"></ui-icon></span>
{#if props.title}
<h3>{props.title}</h3>
{/if}
{#if props.text}
<p>{props.text}</p>
{/if}
<div class="actions"><slot /></div>
</div>`
};
}

Fez('ui-empty', __fez_component_0);

export default __fez_component_0;
